var map = {
	"./australia": 17,
	"./australia.png": 17,
	"./default-150x150": 18,
	"./default-150x150.png": 18,
	"./hbd": 19,
	"./hbd.png": 19,
	"./institute": 20,
	"./institute.jpg": 20,
	"./photo1": 21,
	"./photo1.jpg": 21,
	"./social-share-button/delicious": 22,
	"./social-share-button/delicious.svg": 22,
	"./social-share-button/douban": 23,
	"./social-share-button/douban.svg": 23,
	"./social-share-button/email": 24,
	"./social-share-button/email.svg": 24,
	"./social-share-button/facebook": 25,
	"./social-share-button/facebook.svg": 25,
	"./social-share-button/google_bookmark": 26,
	"./social-share-button/google_bookmark.svg": 26,
	"./social-share-button/google_plus": 27,
	"./social-share-button/google_plus.svg": 27,
	"./social-share-button/hacker_news": 28,
	"./social-share-button/hacker_news.svg": 28,
	"./social-share-button/linkedin": 29,
	"./social-share-button/linkedin.svg": 29,
	"./social-share-button/odnoklassniki": 30,
	"./social-share-button/odnoklassniki.svg": 30,
	"./social-share-button/pinterest": 31,
	"./social-share-button/pinterest.svg": 31,
	"./social-share-button/qq": 32,
	"./social-share-button/qq.svg": 32,
	"./social-share-button/reddit": 33,
	"./social-share-button/reddit.svg": 33,
	"./social-share-button/telegram": 34,
	"./social-share-button/telegram.svg": 34,
	"./social-share-button/tumblr": 35,
	"./social-share-button/tumblr.svg": 35,
	"./social-share-button/twitter": 36,
	"./social-share-button/twitter.svg": 36,
	"./social-share-button/vkontakte": 37,
	"./social-share-button/vkontakte.svg": 37,
	"./social-share-button/wechat": 38,
	"./social-share-button/wechat.svg": 38,
	"./social-share-button/weibo": 39,
	"./social-share-button/weibo.svg": 39,
	"./social-share-button/whatsapp": 40,
	"./social-share-button/whatsapp.svg": 40,
	"./social-share-button/xing": 41,
	"./social-share-button/xing.svg": 41,
	"./syftet_logo": 42,
	"./syftet_logo.jpg": 42,
	"./user1-128x128": 43,
	"./user1-128x128.jpg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;